var React = require('react');

function ChevronUpDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M10.53 3.47a.75.75 0 0 0-1.06 0L6.22 6.72a.75.75 0 0 0 1.06 1.06L10 5.06l2.72 2.72a.75.75 0 1 0 1.06-1.06l-3.25-3.25Zm-4.31 9.81 3.25 3.25a.75.75 0 0 0 1.06 0l3.25-3.25a.75.75 0 1 0-1.06-1.06L10 14.94l-2.72-2.72a.75.75 0 0 0-1.06 1.06Z","clipRule":"evenodd"}));
}

ChevronUpDown.defaultProps = {"viewBox":"0 0 20 20","height":"20","width":"20","fill":"black","aria-hidden":"true","data-slot":"icon"};

module.exports = ChevronUpDown;

ChevronUpDown.default = ChevronUpDown;
